export var AgentEditMode;
(function (AgentEditMode) {
    AgentEditMode["ChatBuilder"] = "chat-builder";
    AgentEditMode["ManualEditing"] = "manual-editing";
})(AgentEditMode || (AgentEditMode = {}));
//# sourceMappingURL=agent-builder.types.js.map